<widget-header
  [name]="widgetName"
  [editable]="false">

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

<turbo-frame
  class="grid--widget-content"
  [id]="frameId"
  [src]="src"
  loading="lazy">
</turbo-frame>
